import { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle } from 'lucide-react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    clinicName: '',
    message: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Frontend mockup - just show success state
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ name: '', email: '', clinicName: '', message: '' });
    }, 3000);
  };

  return (
    <motion.form
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      onSubmit={handleSubmit}
      className="space-y-8"
      data-testid="contact-form"
    >
      {isSubmitted ? (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="flex flex-col items-center justify-center py-16 text-center"
        >
          <CheckCircle className="w-16 h-16 text-[#1A1A1A] mb-6" />
          <h3 className="heading-3 mb-4">Thank You</h3>
          <p className="body-text text-[#595959]">
            We'll be in touch with you shortly.
          </p>
        </motion.div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <label className="overline text-[#595959] block mb-2">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your name"
                className="input-underline"
                data-testid="contact-name-input"
              />
            </div>
            <div>
              <label className="overline text-[#595959] block mb-2">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your@email.com"
                className="input-underline"
                data-testid="contact-email-input"
              />
            </div>
          </div>

          <div>
            <label className="overline text-[#595959] block mb-2">Clinic Name</label>
            <input
              type="text"
              name="clinicName"
              value={formData.clinicName}
              onChange={handleChange}
              placeholder="Your clinic or practice name"
              className="input-underline"
              data-testid="contact-clinic-input"
            />
          </div>

          <div>
            <label className="overline text-[#595959] block mb-2">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={4}
              placeholder="How can we help you?"
              className="input-underline resize-none"
              data-testid="contact-message-input"
            />
          </div>

          <button
            type="submit"
            className="btn-primary flex items-center gap-3 group"
            data-testid="contact-submit-btn"
          >
            <span>Send Message</span>
            <Send className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </>
      )}
    </motion.form>
  );
};

export default ContactForm;
